import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import { EDUCATION_STUDENTS, STUDENTS_PATH } from "utils/constants";
import ListStudents from "./List";
import permissions from "app/permissions";
import ShowStudents from "./Show/Show";

//permissions
export const resources = {
  isMenu: true,
  icon: <PeopleOutlineIcon />,
  name: STUDENTS_PATH + "/" + EDUCATION_STUDENTS,
  title: "Студенти",
  list: <ListStudents />,
  // create: <CreateStudents />,
  // edit: <EditStudents />,
  show: <ShowStudents />,
  permission: permissions.canPreviewStudentEducationInfo,
};
